import { useRouter } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { Icon } from 'ucl/components/icon/Icon';

import ActionButton, { ActionButtonVariants, ActionLink } from 'components/action-button';
import useFeatureMenuAddOn from 'hooks/use-feature-menu-add-on';
import { routes } from 'navigation/routing';
import { t } from 'state/intl/translations';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

const CONDIMENTS_SECTION_ID = '1b024440-71e2-4566-900a-40fceaf5640b';

export const AddMoreButtonsSection = () => {
  const router = useRouter();

  const { sections: addOnSections } = useFeatureMenuAddOn();
  const hasAddOns = addOnSections.length > 0;

  return (
    <View style={styles.container}>
      {hasAddOns && (
        <ActionLink
          to={`${routes.menu}/section/${CONDIMENTS_SECTION_ID}`}
          startIcon={<Icon variant="add" {...hiddenAccessibilityPlatformProps} />}
          variant={ActionButtonVariants.OUTLINE}
          flex={1}
        >
          {t('addCondiments')}
        </ActionLink>
      )}
      <ActionButton
        onPress={() => router.navigate(routes.menu)}
        startIcon={<Icon variant="add" {...hiddenAccessibilityPlatformProps} />}
        variant={ActionButtonVariants.OUTLINE}
        eventAttributes={{
          Name: t('addItemsLowerCase'),
        }}
        flex={1}
      >
        {t('addItems')}
      </ActionButton>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flex: 1,
    gap: 10,
  },
});
